import { FormStatusType } from '@/enums/form-status.enum'
import { GlobalUiState } from '../models'

/**
 * GLOBAL INITIAL STATE
 */
const initialState: GlobalUiState = {
  isLoadingFull: false,
  snackbar: {
    message: '',
    open: false,
    variant: 'success',
  },
  dialog: {
    open: false,
  },
  dialogs: [],
  drawer: {
    open: false,
  },
  dialogConfirm: {
    open: false,
    action: 'delete',
    type: '',
    id: '',
  },
  popoverConfirm: {
    open: false,
    action: 'delete',
    type: '',
    anchorPosition: {
      top: 0,
      left: 0,
    },
  },
  sidebarStatus: false,
  formMode: FormStatusType.CREATE,
}

export default initialState
